// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"88":"login-page","167":"gallery-edit","278":"gallery-listing"}[chunkId] || chunkId) + "-legacy." + {"88":"37632e29","167":"6e58f3d7","185":"723d7458","191":"94071bbc","252":"24486f69","278":"26d8afe8"}[chunkId] + ".js";
};